export const formatMoney = (
  value,
  { currencySymbol = '$', currencyCode = 'USD', minimumFractionDigits = 2, maximumFractionDigits = 2, locale } = {}
) => {
  const amount = Number.isFinite(Number(value)) ? Number(value) : 0
  const formattedAmount = amount.toLocaleString(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  })

  const symbol = typeof currencySymbol === 'string' && currencySymbol.trim()
    ? currencySymbol.trim()
    : null

  if (symbol) {
    return `${symbol}${formattedAmount}`
  }

  const code = typeof currencyCode === 'string' && currencyCode.trim()
    ? currencyCode.trim().toUpperCase()
    : 'USD'

  return `${code} ${formattedAmount}`
}

export const formatDashboardCurrency = (value, { code = 'USD', symbol = '$', locale } = {}) =>
  formatMoney(value, { currencyCode: code, currencySymbol: symbol, locale })
